export const GET_ALL = "GET_ALL";
export const SET_ONESOCIAL = "SET_ONESOCIAL";
export const SET_ONECONTACT = "SET_ONECONTACT";

